/**
 * Les documents contractuels que l'on fait accepter, et LEUR VERSION.
 *
 * UNE SEULE SOURCE, parce que trois ecrans la portent : l'inscription, l'acceptation
 * d'une invitation de projet, et celle d'une invitation d'organisation. Les trois creent
 * un compte, les trois doivent donc recueillir l'acceptation -- et trois copies de la
 * version auraient fini par diverger, ce qui ferait enregistrer une acceptation pour un
 * texte que la personne n'a pas vu. Une preuve fausse est pire qu'une preuve absente.
 *
 * CE QUI EST AFFICHE EST CE QUI EST ENVOYE : la meme constante remplit le libelle de la
 * case et part dans la requete, ou l'API l'ecrit dans `users.conditions_version_acceptee`.
 *
 * A INCREMENTER AVEC LE DOCUMENT. https://nubiecloud.io/conditions porte sa version en
 * evidence ; si elle bouge la-bas sans bouger ici, on enregistre une acceptation pour un
 * texte que personne n'a lu.
 */
export const VERSION_CONDITIONS = '1.0';

export const URL_CONDITIONS = 'https://nubiecloud.io/conditions';
export const URL_CONFIDENTIALITE = 'https://nubiecloud.io/confidentialite';
